const featureStore: Record<string, boolean> = {};

export const hydrateFeatures = () => {
  const paramsString = window?.location.href.split('?')[1];
  const searchParams = new URLSearchParams(paramsString);
  const features = searchParams.get('features');

  if (features) {
    features.split(',').forEach((feature) => {
      featureStore[feature] = true;
    });
  }
};

const activeFeatures = [
  'preference-center',
  'old-preference-center',
  'show-hidden-preferences',
] as const;
type FeatureName = (typeof activeFeatures)[number];

export const isFeatureActive = (featureName: FeatureName): boolean =>
  Boolean(featureStore[featureName]);
